<template>
  <div>
    <Header />
    <div class="content">
      <div class="step">
        <h2>Job Opportunities</h2>
        <div v-if="step != 10">
          <p>Apply for a Job in Just 2 Simple Steps!</p>
          <JobApplyStep :step="step" />
        </div>
      </div>
      <slot />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from 'components/layouts/job_apply/Header.vue'
import Footer from 'components/layouts/lp/Footer.vue'
import JobApplyStep from 'components/ui/JobApplyStep.vue'

export default {
  name: 'JobApplyLayout',

  components: {
    Header,
    Footer,
    JobApplyStep,
  },

  props: {
    step: {
      type: Number,
      default: 0,
      required: true,
    },
  },
}
</script>

<style scoped lang="scss">
@import 'stylesheets/global';

.content {
  margin-bottom: 100px;

  h2 {
    font-size: 28px;
    padding: 15px 0;
  }

  p {
    font-size: 16px;
    padding-bottom: 20px;
    padding-top: 10px;
  }

  .step {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
}
</style>
